export const FILTERS_NOT_FOR_DISPLAY = [
  'booked',
  'dataSource',
  'ordering',
  'page',
  'price_type',
  'searchOrigin',
  'seed',
  'sort',
];

export const filterKeys = [
  'engine-power__gte',
  'engine-power__lte',
  'engine-size__gte',
  'engine-size__lte',
  'ev-wltp-range__gte',
  'ev-wltp-range__lte',
  'filter-only',
  'fuel-type',
  'gear-box',
  'monthly-price__gte',
  'monthly-price__lte',
  'price-reduced',
  'reduced-content',
  'body-type',
  'color',
  'heycar-id',
  'max-distance',
  'd2c',
  'rac',
  'doors',
  'ecom',
  'make',
  'lat',
  'lon',
  'mileage__gte',
  'mileage__lte',
  'model',
  'variant-type',
  'stock-condition',
  'page',
  'postcode',
  'price__gte',
  'price__lte',
  'seats',
  'sort',
  'year__gte',
  'year__lte',
  'region',
  'area',
  'finance-product',
  'eligible-products',
  'vehicle-status',
  // seo filters
  'dealership-id',
  'fuel-consumption__gte',
  'fuel-consumption__lte',
  // wholesale
  'registration',
  'location',
  'v5',
  'mot',
  'ending-soon',
  'vat-status',
  'sold-as-seen',
  'previous-owners',
  'auction-grade',
  'cap__gte',
  'cap__lte',
  'cascade-price__gte',
  'cascade-price__lte',
];
